import React from 'react'

import "./About.css"
import Navbar from '../../Navbar/Navbar'

import team from "../../../assets/imgs/team.png"

function About() {
  return (
    <>
    <Navbar />
    <div className='about'>
      <div className='about-sec-1'>
        <span style={{color:'#596BA4'}}>The Inception of SyncVerse</span>
        <p>The inception of SyncVerse was inspired by a deep understanding of the devastating consequences that fire accidents can have on individuals, businesses, and communities. Witnessing the impact firsthand, our founders recognized the urgent need for innovative safety solutions that could prevent such tragedies from occurring.</p>

      </div>
      <div className='about-sec-2'>
        <span style={{color:'#596BA4'}}>Our Vission</span>
        <div className='about-sec-2-details'>
          <p>SyncVerse was founded with a singular vision: 
Our mission is to create a safer world by offering reliable, state-of-the-art safety solutions that meet the diverse needs of our clients. Our team of experts combines cutting-edge technology with industry-leading knowledge to develop products that meet the highest standards of quality and performance. We take pride in our meticulous attention to detail and rigorous testing procedures, ensuring that each product we deliver exceeds your expectations.</p>
<img src="" alt="" />

        </div>

      </div>
      <div className='about-sec-1'>
        <span style={{color:'#596BA4'}}>How are we different?</span>
        <p>From the outset, SyncVerse has been dedicated to engineering and manufacturing top-of-the-line safety goods. We set out to produce not just ordinary fire alarms and gas detectors, but technologically advanced, reliable, and highly effective products that surpass expectations. Our comprehensive range of safety goods includes fire alarm systems and gas detectors, specifically designed to detect, alert, and mitigate potential fire hazards. We understand that every environment is unique, which is why we offer a tailored approach, customizing our solutions to meet the specific needs of each client. Whether you are a small business, a large industry, or a homeowner, we have the perfect safety solution to suit your requirements.</p>

      </div>
      <div className='about-sec-1'>
      <span style={{color:'#596BA4'}}>Why Choose SyncVerse?</span>
      <p><strong>Uncompromising Quality:</strong> At SyncVerse, quality is at the core of everything we do. Our products undergo rigorous testing and adhere to stringent international safety standards. We ensure that each item leaving our facility is built to last and provide optimal performance. <br /><br />

<strong>Cutting-Edge Technology:</strong> We stay ahead of the curve by harnessing the power of the latest technological advancements. Our team of experienced engineers and designers work tirelessly to develop innovative solutions that deliver superior performance, accuracy, and reliability. <br /><br />


<strong>Customized Solutions:</strong> We recognize that every client has unique safety requirements. That's why we offer customizable solutions tailored to meet your specific needs. Whether you are a small business, a large industrial facility, or a homeowner, we have the right safety products to safeguard your environment effectively. <br /><br />


<strong>Exceptional Service:</strong> At SyncVerse, we prioritize customer satisfaction above all else. Our dedicated support team is always ready to assist you with any inquiries, technical support, or product guidance. We are committed to ensuring a seamless experience from purchase to installation and beyond. <br /><br />


<strong>Sustainability:</strong> We are deeply committed to environmental sustainability. Our products are designed with eco-friendly materials and energy-efficient features, reducing their impact on the planet. By choosing SyncVerse, you not only protect lives but also contribute to a greener future. <br /><br />

</p>

      </div>
      <div className='ourTeam'>
        <span>Our Team</span>
        <div className='ourTeamDetails'>

        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        </div>

      </div>
      <div className='ourTeam'>
        <span>Our Mentors</span>
        <div className='ourTeamDetails'>

        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        <div className='card'>
          <img src={team} alt="" />
          <div className='cardDetails'>
            <span>Person1</span>
            <span>Founder</span>
            <p>Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis. Lorem ipsum dolor sit amet consectetur. In ac tempus eget iaculis.</p>

          </div>
        </div>
        </div>

      </div>
    </div>
    </>
  )
}

export default About
